import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { filter, Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TraceabilityReportService {

  constructor(private http: HttpClient) { }

  getProcessOrderDataFilters(params: any) { 
    return this.http.get<any>(environment.baseUrl + 'Reports/Filter/GetProcessOrderDataFilters', {params});
  }
  getPackedDates(params: any) { 
    return this.http.get<any>(environment.baseUrl + 'Reports/Filter/GetPackedDates', {params});
  }
  /**Process order number */
  getProcessOrderByNo(params: any) {   
    return this.http.get<any>(environment.baseUrl + 'Reports/Filter/GetProcessOrderNoByDate', {params});
  }
  /**Lot Number */
  getLotNumber(params: any) {  
    return this.http.get<any>(environment.baseUrl + 'Reports/Filter/GetLotNoByDate', {params});
  }
  /**Lot Number */
  getRunNumber(params: any) {   
    return this.http.get<any>(environment.baseUrl + 'Reports/Filter/GetRunNoByDate', {params});
  }
  
  getGLAPData(params: any): Observable<any> {
  // const params = filters;
    // return this.http.get<any>(environment.baseUrl + 'Reports/Report/GetProcessOrderData', {params});    
    return this.http.get(environment.baseUrl + 'Reports/Report/GetProcessOrderDataDownload', {params: params, responseType: 'blob' });
  }

  getITWData(params: any): Observable<any> {
  //  return this.http.get<any>(environment.baseUrl + 'Reports/Report/GetITWData', {params});  
  //  return this.http.get<any>(environment.baseUrl + 'Reports/Report/GetITWDataDownload', {params});  
   return this.http.get(environment.baseUrl + 'Reports/Report/GetITWDataDownload', {params: params, responseType: 'blob' });
  }

  fetchReportData(reportType: string, filters: any): Observable<any[]> {
    if (reportType === 'GLAP') {
      return this.getGLAPData(filters);
    } else if (reportType === 'ITW') {
      return this.getITWData(filters);
    } else {
      return of([]);
    }
  }
}
